<template>
    <b-modal ref="modal" centered hide-header  no-close-on-backdrop no-close-on-esc hide-footer size="lg">
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('USER')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group"  v-if="formData != null">
                <div class="form-row mb-lg">
                    <div class="col-sm-4">
                        <strong>{{$t('BASICDATA')}}</strong>
                    </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('USERNAME')">
                            <inputvalidation :formerror="formError" name="username"><b-form-input type="text" v-model="formData.username" v-bind:placeholder="$t('USERNAME')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('PASSWORD')">
                            <inputvalidation :formerror="formError" name="password"><b-form-input type="password" v-model="formData.password" v-bind:placeholder="$t('PASSWORD')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('USEREMAIL')">
                            <inputvalidation :formerror="formError" name="userEmail"><b-form-input type="email" v-model="formData.userEmail" v-bind:placeholder="$t('USEREMAIL')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                        <div class="col-sm-6" v-if="!newuser">
                            <b-form-fieldset v-bind:label="$t('USERGROUP')">
                                <inputvalidation :formerror="formError" name="groupId">
                                    <lbselect 
                                    :list="aclGroups.root" 
                                    v-model="formData.groupId"
                                    :total-count="aclGroups.totalCount"
                                    :pagination="aclGroupsPagination"
                                    v-on:reload="getAclGroups()"
                                    value-field="groupId" 
                                    display-field="groupName">
                                    </lbselect>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-6">
                            <b-form-fieldset v-bind:label="$t('STATUS')">
                                <inputvalidation :formerror="formError" name="status">
                                    <b-form-select :options="status" v-model="formData.status"></b-form-select>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-6" v-if="(globals && globals.acl && globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.insertAction && showSubCompany == 1)">
                            <b-form-fieldset v-bind:label="$t('SUBCOMPANY')">
                                <inputvalidation :formerror="formError" name="subCompanyId">
                                    <b-form-select :options="userSubCompanies.root" v-model="formData.subCompanyId" value-field="subCompanyId" text-field="subCompanyName"></b-form-select>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6" v-if="(globals && globals.acl && globals.acl.UserCompanies && globals.acl.UserCompanies.insertAction && showComany == 1 && !showSubCompany)">
                            <b-form-fieldset v-bind:label="$t('COMPANY')">
                                <inputvalidation :formerror="formError" name="companyId">
                                    <b-form-select :options="userCompanies.root" v-model="formData.companyId" value-field="companyId" text-field="companyName">
                                    </b-form-select>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="form-row mt-lg mb-lg">
                        <div class="col-sm-4">
                        <strong>{{$t('ADDITIONALDATA')}}</strong>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('NAME')">
                            <inputvalidation :formerror="formError" name="name"><b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('SURNAME')">
                            <inputvalidation :formerror="formError" name="surname"><b-form-input type="text" v-model="formData.surname" v-bind:placeholder="$t('SURNAME')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('ADDRESS')">
                            <inputvalidation :formerror="formError" name="address"><b-form-input type="text" v-model="formData.address" v-bind:placeholder="$t('ADDRESS')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('CITY')">
                            <inputvalidation :formerror="formError" name="city"><b-form-input type="text" v-model="formData.city" v-bind:placeholder="$t('CITY')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6">
                            <b-form-fieldset v-bind:label="$t('POSTALCODE')">
                                <inputvalidation :formerror="formError" name="postalCode"><b-form-input type="text" v-model="formData.postalCode" v-bind:placeholder="$t('POSTALCODE')"></b-form-input></inputvalidation>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-6">
                            <b-form-fieldset v-bind:label="$t('COUNTRY')">
                                <inputvalidation :formerror="formError" name="country"><b-form-input type="text" v-model="formData.country" v-bind:placeholder="$t('COUNTRY')"></b-form-input></inputvalidation>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('PHONE')">
                            <inputvalidation :formerror="formError" name="phone"><b-form-input type="text" v-model="formData.phone" v-bind:placeholder="$t('PHONE')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                        <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('TAXNUMBER')">
                            <inputvalidation :formerror="formError" name="taxNumber"><b-form-input type="text" v-model="formData.taxNumber" v-bind:placeholder="$t('TAXNUMBER')"></b-form-input></inputvalidation>
                        </b-form-fieldset>
                        </div>
                    </div>
                </div>
          </div>
            <div class="text-center mt-lg mb-lg">
                <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
                <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
            </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/admin/Users'
import AclGroupsApi from '@/api/admin/acl_groups/AclGroups.js';
import SubCompaniesApi from '@/api/admin/UserSubCompanies';
import CompaniesApi from '@/api/admin/UserCompanies'


export default
{
    name: 'UsersForm',
    props: ['value'],
    data()
    {
        const me = this;

        const pagDefault = {
            query: '',
            currentPage: 1,
            initialId: [],
            limit: 50000,
            searchTimeout: false,
        };

        return {
            aclGroups: {},
            showComany: 0,
            showSubCompany: 0,
            userSubCompanies: {},
            userCompanies: {},
            formError: {},            
            newuser: false,
            formData: null,
            status:
            [
                {
                value: 'active',
                text: me.$i18n.t('ACTIVE')
                },
                {
                value: 'inactive',
                text: me.$i18n.t('INACTIVE')
                }
            ],
            aclGroupsPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 50000,
                searchTimeout: false,
            },
        };
    },
    methods:
    {
        async submitData(item)
      {
          const me = this;
            try
            {
                if (typeof item.userId !== 'undefined')
                {
                    item.id = item.userId;
                    delete (item.userId);
                }

                const val = await Api.save(item);

                if (val.error)
                {
                    me.$notify.notice(val);
                    me.formError = val;
                }
                else
                {
                    me.$notify.notice(val);
                    me.close();
                }
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
      },
        async getCompanies()
      {
          const me = this;
          try
          {
              const data = await CompaniesApi.selectRow({start:0, limit: 5000});
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.userCompanies = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getSubCompanies()
      {
          const me = this;
          try
          {
              const data = await SubCompaniesApi.selectRow({start:0, limit: 5000});
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.userSubCompanies = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getAclGroups()
      {
          const me = this;
          try
          {
              const data = await AclGroupsApi.selectRow(me.getAclGroupsParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.aclGroups = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
        close()
        {
            const me = this;
            me.newuser = false;
            me.formData = null;
            me.showComany = 0;
            me.showSubCompany = 0;
            me.formError = {};
            me.aclGroups = {};
            me.userSubCompanies = {};
            me.userCompanies = {};
            me.$emit('close');
        },
    },
    watch:
    {
        'formData.groupId': function (val)
        {
            const me = this;
            
            switch (String(val)) {
                case '1':
                    me.showComany = 0;
                    me.showSubCompany = 0;
                    break;
                case '5':
                    me.showComany = 0;
                    me.showSubCompany = 0;
                    break;
                case '6':
                    me.showComany = 1;
                    me.showSubCompany = 0;
                    break;
                case '7':
                    me.showComany = 1;
                    me.showSubCompany = 1;
                    break;
                case '8':
                    me.showComany = 1;
                    me.showSubCompany = 1;
                    break;
                case '10':
                    me.showComany = 1;
                    me.showSubCompany = 0;
                    break;
                default:
                    break;
            }
        },
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                val.status = 'active';
                await me.getCompanies();
                await me.getSubCompanies();
                await me.getAclGroups();
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getAclGroupsParams()
      {
          const me = this;
          const data = { ...me.aclGroupsPagination };
          data.start = (data.currentPage - 1) * data.limit;
          if (me.formData != null && me.formData.groupId != null)
          {
              data.initialId = [];
              data.initialId.push(me.formData.groupId);
          }
          return data;
      },
    },
};
</script>
